import UserInfoContract from "./userInfoContract";

/**
 * @constructor
 */
function ShipmentContract(type, addressType) {
    /**
     * @type {string}
     */
    this.type = type || 'normal';
    /**
     * @type {boolean}
     */
    this.submitted = false;
    /**
     * @type {string}
     */
    this.addressType = '';
    /**
     * @type {boolean}
     */
    this.saveAddress = false;

    /**
     * @type {number}
     */
    this.price = 0;

    /**
     * @type {UserInfoContract}
     */
    this.address = new UserInfoContract();
}

export default ShipmentContract;